module.exports = __webpack_public_path__ + "img/member_ic4_news.e916a982.png";